import React from 'react';
import { StyleSheet } from 'react-native';

import DashedLine from 'react-native-dashed-line';

import { scale } from '@components/frame';

export default ({ height, C }) => {
  return (
    <DashedLine
      axis="vertical"
      style={{ height }}
      dashThickness={StyleSheet.hairlineWidth}
      dashLength={scale(2)}
      dashGap={scale(2)}
      dashColor={C('Hairline/Light/No trans')}
    />
  );
};
